import { Corporation, Facture, Person } from "..";
import { CompteSurEntite, EtatDoc, InputModel, QueovalBase, QueovalItem } from "../global";
import { Select } from "../utilities";


export class ConventionModel extends QueovalBase {
  public Clients: Array<ClientConvention>;
  public Dossiers: Array<Select>;
}

export class ClientConvention {
  public Ident: string;
  public RaisoCli: string;
  public CpVille: string;
  public LinkedToStage: boolean;
  public Conventions: Array<ConventionData>;
  public Stages: Array<QueovalItem>;
  public Apprenants: Array<QueovalItem>;
  public Responsables: Array<QueovalItem>;
  public DataRetrieved: boolean;
  public newConvention: ConventionData;
  public IdentEntiteFact: string;
  public EntiteFact: Array<QueovalItem>;
  public NbConventions: number;
  public MontantConventions: number;
  public loading: boolean;
  public displayed: boolean;
}

export class ConventionData {
  constructor() {
    this.saving = false;
    this.generating = false;
    this.deleting = false;
    this.Factures = [];
    this.Stages = [];
    this.Apprenants = [];
    this.Responsables = [];
    this.DefaultInputs = [];
  }
  public Ident: string;
  public Titre: string;
  public Info: string;
  public NumAccord: string;
  public CodeEtatDoc: string;
  public StrNumCvt: string;
  public Reference: string;
  public StrDateCreation: string;
  public StrDateSignature: string;
  public StrDatePerdu: string
  public FileExist: boolean;
  public IdentDossier: string;
  public MontantConvention: number;
  public MontantFactureHt: number;
  public MontantFactureTTC: number;
  public Factures: Array<Facture>;
  public Stages: Array<ConventionStageData>;
  public Apprenants: Array<ConventionApprenantData>;
  public Responsables: Array<ConventionApprenantData>;
  public Financeur: Corporation;
  public IdEntiteFact: string;
  public EntiteLock: boolean;
  public IdEntiteFactProfil: string;
  public IdStageLinked: string;
  public IdClientLinked: string;
  public DefaultInputs: Array<InputModel> = [];

  public saving: boolean;
  public generating: boolean;
  public deleting: boolean;
  public savingThumb: boolean;
  public generatingFact: boolean;
  public showbuttongenerate: boolean;
  public displayed: boolean;
}

export class CalculConventionData {
  public Convention: ConventionData;
  public MontantConvention: number;
  constructor() {
    this.Convention = new ConventionData();
  }
}

export class ConventionStageData extends QueovalItem {
  public ApprenantsLoaded: boolean;
  public Apprenants: Array<ConventionApprenantData>;
  public NumStage: string;
}

export class ConventionApprenantData extends QueovalItem {
  public Count: number;
  public Civilite: string;
  public ApprenantOnClient: boolean;
  public ApprenantOnStage: boolean;
  public TxtStageApprenant: string;
}


